import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CustomerAuthContext = createContext(null);
const TOKEN_KEY = "climomax_customer_token";

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    api.get("/customer/me")
      .then((r) => setCustomer(r.data))
      .catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/customer/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setCustomer(data.customer);
    return data.customer;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await api.post("/customer/register", payload);
    localStorage.setItem(TOKEN_KEY, data.token);
    setCustomer(data.customer);
    return data.customer;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setCustomer(null);
  }, []);

  const forgotPassword = useCallback(async (email) => {
    const { data } = await api.post("/customer/forgot-password", { email });
    return data;
  }, []);

  const resetPassword = useCallback(async (token, password) => {
    const { data } = await api.post("/customer/reset-password", { token, password });
    return data;
  }, []);

  return (
    <CustomerAuthContext.Provider value={{ customer, loading, login, register, logout, forgotPassword, resetPassword }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export function useCustomerAuth() {
  const ctx = useContext(CustomerAuthContext);
  if (!ctx) throw new Error("useCustomerAuth must be used within CustomerAuthProvider");
  return ctx;
}
